import React, { useState, memo, useCallback } from "react";
import { useRecoilState } from "recoil";

import { hospitalInsuranceState } from '../../../store/hospitalInsuranceState';

import { NewInsurance } from '../parts/NewInsurance';
import { EditInsurance } from '../parts/EditInsurance';

export const HospitalInsurance = (props) => {
  const { init_hospital, insurances } = props;
  const [hospitalInsuranceData, setHospitalInsuranceData] = useRecoilState(hospitalInsuranceState);

  const addHospitalInsurance = useCallback((new_item) => {
    setHospitalInsuranceData([...hospitalInsuranceData, new_item]);
  }, [hospitalInsuranceData]);

  const removeHospitalInsurance = useCallback((remove_item) => {
    setHospitalInsuranceData(hospitalInsuranceData.filter(item => {
      return item.id !== remove_item;
    }));
  }, [hospitalInsuranceData]);

  return (
    <>
      <NewInsurance hospital_id={init_hospital.id} insurances={insurances} addHospitalInsurance={addHospitalInsurance} />
      <div className="row">
        <table className="table table-striped table-hover mb-3">
          <tbody>
          {hospitalInsuranceData.map(hospital_insurance => 
              <EditInsurance key={hospital_insurance.id} init_hospital_insurance={hospital_insurance} removeHospitalInsurance={removeHospitalInsurance} />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};